import invariant from 'invariant';
import type { Asset } from '@frameio/graphql-client/generated';
import { isUUID } from '@frameio/utils/formatters';
import { createUrl } from '../helpers/createUrl';
import { getPathnameFromHref } from '../helpers/getPathnameFromHref';
import type { ValidHref } from '../types';

export type PrintGetLinkParams = {
  page: 'print';
  assetId: Asset['id'];
};

export const getLinkForPrint = (params: PrintGetLinkParams): ValidHref => {
  const { assetId } = params;

  // Assert required params for better error messages
  invariant(assetId, 'assetId is required');

  const pathname: ValidHref = `/print/comments/${assetId}`;

  return createUrl({
    pathname,
  });
};

export const isPrintPageType = (href: ValidHref): boolean => {
  const pathname = getPathnameFromHref(href);
  const parts = pathname.split('/');
  return (
    parts.length === 4 &&
    parts[1] === 'print' &&
    parts[2] === 'comments' &&
    isUUID(parts[3])
  );
};
